<template>
  <span>
    <i class="fa fa-comment fa-primary" @click="onShowModal()"/>
    <Modal ref="add-comment-to-order-attachment"
           @onClose="closeModal"
           :values="modalValues">
      <template slot="body">
        <div class="modal-body">
          <b-form-textarea id="textarea" :disabled="isDisabled"
                           :placeholder="'add_comment' | translate('global')" rows="3"
                           v-model="comment"/>
        </div>
      </template>
      <template slot="footer">
        <b-button variant="success" data-dismiss="modal"
                  :disabled="!comment || !comment.length || isDisabled || spinners.isSaving"
                  @click='addComment()'>
          <b-spinner v-if="spinners.isSaving" type="grow" small/>
          {{ 'add' | translate('global') }}
        </b-button>
        <b-button variant="secondary" @click="closeModal()" class="ml-2">{{ 'cancel' | translate('global') }}</b-button>
      </template>
    </Modal>
  </span>
</template>

<script>
import statuses from '@/store/statuses';
import Modal from '@/views/sharedComponents/Modal';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';

const OrdersTypes = VuexTypes.orders;

export default {
  mounted() {
    this.comment = this.data.comment;
  },
  props: {
    data: {
      type: Object,
    },
    isDisabled: Boolean
  },
  data() {
    return {
      spinners: {
        isSaving: false,
      },
      comment: null,
      modalValues: {
        id: 'add-comment-to-order-attachment',
        title: this.$t('add_comment', 'global'),
      },
    };
  },
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('Orders', [
      'orderAddCommentToAttachment',
    ]),
  },
  watch: {
    orderAddCommentToAttachment: {
      handler: function () {
        if (this.orderAddCommentToAttachment.status !== statuses.LOADING) {
          this.spinners.isSaving = false;
          this.closeModal();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Orders', [
      OrdersTypes.ORDER_ADD_COMMENT_TO_ATTACHMENT,
    ]),
    onShowModal() {
      this.$refs['add-comment-to-order-attachment'].show();
    },
    closeModal() {
      this.$refs['add-comment-to-order-attachment'].hide();
    },
    addComment() {
      this.spinners.isSaving = true;
      this.ORDER_ADD_COMMENT_TO_ATTACHMENT({
        orderId: this.$route.params.id,
        attachmentId: this.data.id,
        comment: { comment: this.comment }
      });
    },
  }
};
</script>
